"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    male: '男',
    female: '女',
};
